module.exports = __webpack_public_path__ + "static/media/ourMissionImage.ba89f286.svg";